import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityTrustSignals = () => {
  const trustSignals = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      title: 'SOC 2 Compliant',
      description: 'Enterprise security'
    },
    {
      icon: 'CheckCircle',
      title: 'ISO 27001',
      description: 'Certified secure'
    }
  ];

  const securityFeatures = [
    'Multi-factor authentication',
    'Session timeout protection',
    'Audit trail logging',
    'Role-based access control'
  ];

  return (
    <div className="space-y-6">
      {/* Trust Badges */}
      <div className="grid grid-cols-3 gap-4">
        {trustSignals?.map((signal, index) => (
          <div key={index} className="text-center">
            <div className="flex items-center justify-center w-12 h-12 bg-success/20 rounded-full mx-auto mb-2">
              <Icon name={signal?.icon} size={20} className="text-success" />
            </div>
            <h4 className="text-xs font-medium text-foreground mb-1">{signal?.title}</h4>
            <p className="text-xs text-muted-foreground">{signal?.description}</p>
          </div>
        ))}
      </div>
      {/* Security Features */}
      <div className="bg-muted/20 rounded-lg p-4">
        <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center">
          <Icon name="ShieldCheck" size={16} className="text-success mr-2" />
          Security Features
        </h3>
        <ul className="space-y-2">
          {securityFeatures?.map((feature, index) => (
            <li key={index} className="flex items-center text-xs text-muted-foreground">
              <Icon name="Check" size={14} className="text-success mr-2 flex-shrink-0" />
              {feature}
            </li>
          ))}
        </ul>
      </div>
      {/* Compliance Info */}
      <div className="text-center">
        <p className="text-xs text-muted-foreground mb-2">
          Trusted by 500+ organizations worldwide
        </p>
        <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
          <span className="flex items-center">
            <Icon name="Globe" size={12} className="mr-1" />
            Global
          </span>
          <span className="flex items-center">
            <Icon name="Clock" size={12} className="mr-1" />
            24/7 Support
          </span>
          <span className="flex items-center">
            <Icon name="Users" size={12} className="mr-1" />
            Enterprise
          </span>
        </div>
      </div>
      {/* Footer */}
      <div className="text-center pt-4 border-t border-border">
        <p className="text-xs text-muted-foreground">
          © {new Date()?.getFullYear()} SecureLock Systems. All rights reserved.
        </p>
        <div className="flex items-center justify-center space-x-4 mt-2">
          <a href="#" className="text-xs text-muted-foreground hover:text-foreground security-transition">
            Privacy Policy
          </a>
          <a href="#" className="text-xs text-muted-foreground hover:text-foreground security-transition">
            Terms of Service
          </a>
          <a href="#" className="text-xs text-muted-foreground hover:text-foreground security-transition">
            Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default SecurityTrustSignals;